export enum Constants {
  REQUEST_SUBSCRIPTIONS_START = 'REQUEST_SUBSCRIPTIONS_START',
  RELOAD_SUBSCRIPTIONS_START = 'RELOAD_SUBSCRIPTIONS_START',
  REQUEST_SUBSCRIPTIONS_SUCCESS = 'REQUEST_SUBSCRIPTIONS_SUCCESS',
  REQUEST_SUBSCRIPTIONS_ERROR = 'REQUEST_SUBSCRIPTIONS_ERROR',
}
